<ion-toolbar>
  <ion-buttons slot="start">

    <ion-menu-button *ngIf="showButton === 'menu'"></ion-menu-button>
    <ion-back-button *ngIf="showButton === 'back'"  [defaultHref]="menuService.homePageUrl" (click)="closeModal()"></ion-back-button>
    <ion-button *ngIf="false" style="--color: #adadad" [routerLink]="routeInfo?.url"
      [routerDirection]="routeInfo?.direction">
      <ion-icon name="chevron-back-outline"></ion-icon>
    </ion-button>
  </ion-buttons>

  <ion-title>
    {{title}}
    <ion-img *ngIf="!title" class="title-image" [src]="logoUrl"></ion-img>
  </ion-title>

  <ion-button class="btn-right-group" *ngIf="canShow()" (click)="openNotificationPage()" slot="end" fill="clear">
    <span [ngClass]="isUnreadNotification() ? 'active' : null "></span>
    <ion-icon name="notifications-outline">
    </ion-icon>
  </ion-button>
  <ion-button class="btn-right-group" *ngIf="canShow()" slot="end" fill="clear">
    <ion-icon name="settings-sharp"></ion-icon>
  </ion-button>

</ion-toolbar>